// 发布项目模块
export default {
    PublishProject: {
        StartPublishing: '开始发布',
        ShareableQuestionnaire: '开启发布后，即可分享问卷',
        ProjectSharing: '项目分享',
        LinkRemainsUnchanged: '项目发布后，链接与二维码始终不变',
        ShareLink: '分享链接',
        Copy: '复制',
        Open: '打开',
        QRCode: '二维码',
        DownloadQRCode: '下载二维码',
        WeChatSharing: '微信分享',
        UploadLogo: '上传Logo',
        ShareLogo: '分享logo',
        ClickToUpload: '点击上传',
        ClickToDelete: '点击删除',
        ImageSupport: '图片支持png、jpg格式,建议尺寸100*100',
        InputContent: '请输入联系人姓名',
        ShareTitle: '分享标题',
        ShareDescriptionDescription: '分享描述说明',
        FriendSharingPreview: '好友分享预览',
        ShareMomentPreview: '分享朋友圈预览',
        WeChatAvatar: '微信头像',
        WeChatNickname: '微信昵称',
        SMSSharing: '短信分享',
        ViewSentTextMessages: '查看已发送短信',
        AddRecipient: '添加收件人',
        EditContent: '编辑内容',
        Sent: '已经发送',
        BriefIntroduction: '您可以从左侧联系人列表中添加，或手动输入“手机号,姓名”，每行代表一个联系人，姓名可以出现在短信正文中。例如：136xxxxxxxx,宋先生',
        ContactList: '联系人列表',
        Add: '添加',
        ManuallyEnteringContacts: '手动输入联系人',
        NumberOfRecipients: '收件人数',
        NextStep: '下一步',
        InstructionsForUse: '使用须知：',
        InstructionsForUse1: '1.您发送的短信需要经过内容审核',
        InstructionsForUse2: '2.短信抬头将显示为【东方艾学代发】',
        InstructionsForUse3: '3.发送成功后，可以查看已发短信的进度',
        InstructionsForUse4: '4.$[name]表示联系人姓名 $[surveylink]表示问卷地址',
        InstructionsForUse5: '5.给异常的手机号（包括停机，空号等）发送短信，也会扣除短信余额或账户余额',
        Back: '上一步',
        Sending: '发送',
        SubmittedForSending: '已经提交发送。',
        SMSSent: '已发送短信',
        SMSContent: '短信内容',
        NumberOfSenders: '发送人数',
        SendingTime: '发送时间',
        State: '状态',
        SMSDelivered: '短信已投递',
        SMSNotDelivered: '短信未投递',
        SMSDeliveryFailed: '短信投递失败',
        Reason: '原因',
        Operate: '操作',
        ViewDetails: '查看详情',
        BackSentSMSList: '返回已发送短信列表',
        PhoneNumber: '手机号码',
        Name: '姓名',
        Success: '成功',
        Fail: '失败',
        EmailSharing: '邮件分享',
        ViewSharedEmails: '查看已分享邮件',
        SelectSendingMethod: '选择发送方式',
        EmailContactDescription: '您可以从左侧“通讯录”中批量添加，或在右侧手动输入收件人邮箱（或“邮箱,姓名”）。每次最多添加500个。',
        InstructionsForUse: '使用说明：“$[name]”表示收件人姓名，“$[surveylink]”表示测评地址',
        Addresser: '发件人',
        SenderEmail: '发件人邮箱',
        Theme: '主题',
        SendViaEmail: '使用神采问卷邮箱发送',
        SendViaEmail1: '统一显示神采问卷的发件邮箱地址:ai@almail.ai-learning.com.cn',
        SendViaEmail2: '每封邮件消耗一条邮件余额,邮件余额需充值购买。',
        MailRemaining: '邮件剩余',
        RechargePurchase: '充值购买',
        SendUsingYourOwnEmail: '使用自有邮箱发送',
        BindingRequired: '需绑定个人邮箱或企业邮箱,显示您的发件邮箱地址,提升品牌形象,不消耗邮件余额,发送成功率更可靠。',
        LimitedToAdvancedVersionUse: '限高级版使用',
        UpgradeNow: '立即升级',
        NotYetOpen: '暂未开放',
        SentMail: '已发送邮件',
        EmailSubject: '邮件主题',
        SendingMethod: '发送方式',
        Undelivered: '未投递',
        Delivered: '已投递',
        DeliveryFailed: '投递失败',
        BackToTheListOfSentEmails: '返回已发送邮件列表',
        Mailbox: '邮箱',
        None: '暂无',
        SendConfirmation: '发送确认',
        ContentContainsCharacters: '内容包含字符数',
        NumberOfConsumptionItems: '将消费短信余额条数',
        NumberOfContactsToBeSent: '本条短信将发送联系人数',
        TotalConsumptionSMSBalance: '总共消费短信余额数',
        SMSBalance: '短信余额',
        Strip: '条',
        Recharge: '充值',
        ReturnToModification: '返回修改',
        ModificationPrompt: '修改提示',
        AreYouSureToModifyThisQuestionnaire: '您确认修改此问卷吗？该问卷所有数据收集将被停止，答卷链接暂时关闭！',
        Wildcard: '$[surveylink] 是代表问卷唯一链接的通配符，请勿删除！删除后收件人将看不见答题地址。点击确定可重新添加 $[surveylink]',
        QuestionControl: '题目控件',
        MyQuestionBank: '我的题库',
        ForExample: '如',
        Recipient: '如：东方艾学',
        Investigate: '神采问卷课调查',
        TelephoneSurveys: '电访',
        Interview: '面访',
        SetUp: '设置',
        PleaseWaitAMoment: '请稍后',
        InsufficientSMSBalance: '短信余额不足,请及时充值',
        SuccessfullySent: '发送成功',
        NoContactsToSend: '您无可发送的联系人',
        FillInTheEmailSubject: '请填写邮件主题！',
        InsufficientEmailBalance: '邮件余额不足，请充值购买！',
        SuccessfullyCopied: '复制成功！',
        AndaPastiInginMenerbitkan: '确定要发表吗',
        Penerbitan: '正在发布，请稍后',
        BerjayaDiterbitkan: '发布成功！',
        TidakDiterbitkan: '已取消发布',
        SetBerjaya: '设置成功',
        PadamSecaraKekal: '此操作将永久删除该数据, 是否继续?'

    },
  };